let viewportHeight = window.innerHeight
let lastProgress = -1
let ticking = false

const update = () => {
  ticking = false
  const progress = Math.min(1, Math.max(0, window.scrollY / viewportHeight))
  if (progress === lastProgress) return
  lastProgress = progress
  document.body.style.setProperty('--scroll-fx', progress.toFixed(4))
}

const onScroll = () => {
  if (ticking) return
  ticking = true
  requestAnimationFrame(update)
}

const onResize = () => {
  viewportHeight = window.innerHeight
  onScroll()
}

window.addEventListener('scroll', onScroll, { passive: true })
window.addEventListener('resize', onResize, { passive: true })

update()
